import { render, staticRenderFns } from "./EmployeeInventory.vue?vue&type=template&id=7bf1f48c&scoped=true"
import script from "./EmployeeInventory.vue?vue&type=script&lang=js"
export * from "./EmployeeInventory.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInventory.vue?vue&type=style&index=0&id=7bf1f48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1f48c",
  null
  
)

export default component.exports